import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { baseGrid, siteWide } from '@helpers/grid';
import { from, until } from '@helpers/media';
import FiltersFormContainerStyles, { FiltersFormWrapperStyles, FormWrapperStyles, } from '@stories/Components/Misc/FiltersFormContainer/FiltersFormContainer.styles';
import SkipLinkStyles from '@stories/Components/Misc/SkipLink/SkipLink.styles';
import { rgba } from 'polished';
import styled, { createGlobalStyle } from 'styled-components';
const WrapperStyles = createGlobalStyle `
  .embedded-form-wrapper {
    ${siteWide};
    ${baseGrid};

    padding-top: var(--sectionSpacingTop);
    padding-bottom: var(--sectionSpacingBottom);
    scroll-margin: calc(var(--headerHeight, 0px) + ${fluid(16, 32)}) 0 0;

    ${SkipLinkStyles.Container} {
      grid-column: 1 / -1;
      margin-right: auto;
    }
  }

  .embedded-form-inner {
    ${FiltersFormWrapperStyles};
  }

  .embedded-form-right {
    ${FormWrapperStyles};

    background-color: ${brand.global.white};
    border: 1px solid ${rgba(brand.grey.light, 0.65)};

    @container filters-form-container ${until(675)} {
      border-top: 0;
    }

    @container filters-form-container ${from(675)} {
      border-left: 0;
    }

    .umbraco-forms-page {
      width: 100%;
      padding: 0;
      margin: 0;
    }
  }
`;
const Container = styled(FiltersFormContainerStyles.ContentWrapper) ``;
const Subtitle = styled(FiltersFormContainerStyles.Subtitle) ``;
const Title = styled(FiltersFormContainerStyles.Title) ``;
const Introduction = styled(FiltersFormContainerStyles.Introduction) ``;
const EmbeddedFormStyles = {
    Subtitle,
    Introduction,
    Title,
    Container,
    WrapperStyles,
};
export default EmbeddedFormStyles;
